<template>
  <v-container>
    <v-row dense no-gutters class="mt-10">
      <v-col>
        <div class="d-flex justify-center">
          <span class="sts-description-title mb-8 mr-5">{{$t('pages.downloadAttachments.title')}}</span>
          <infinite-loader v-show="loading" size="25" color="#00B0E3" style="position: relative; top: .5rem;"/>
        </div>
        <p class="sts-description-subtitle text-center">{{$t('pages.downloadAttachments.subtitle')}}</p>
        <p class="text-center">
          <primary-btn
          :label="$t('btns.download')"
          color="#4285f4"
          @click="tryToDownloadAttachment"
          :loading="loading"
          :width="100"
          :height="40"/>
          <a ref="downloadLinkRef" class="d-none" :href="getDownloadLink" target="_self" download>here</a>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import InfiniteLoader from '@/components/common/InfiniteLoader'
import PrimaryBtn from '@/components/btns/PrimaryBtn'
export default {
  components: {
    InfiniteLoader,
    PrimaryBtn
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    getDownloadLink() {
      return `/api/v1/files/download/${this.$route.params.id}`
    }
  },
  methods: {
    async tryToDownloadAttachment() {
      this.loading = true
      this.$refs.downloadLinkRef.click()
      setTimeout(() => this.loading = false, 2000)
    }
  },
  mounted() {
    this.$feedback.fill("Download Attachment Page", this.$route.path)
    this.tryToDownloadAttachment()
  }
}
</script>
<style>
</style>